export const VIRTUAL_EVENTS_CHANGE = {
  VIRTUAL_ITEMS_CHANGE: 'VIRTUAL_ITEMS_CHANGE',
  VIRTUAL_ADDONS_CHANGE: 'VIRTUAL_ADDONS_CHANGE',
  VIRTUAL_ADDITIONALREQUIREMENTS_CHANGE: 'VIRTUAL_ADDITIONALREQUIREMENTS_CHANGE',
  VIRTUAL_TERM_CHANGE: 'VIRTUAL_TERM_CHANGE',
  VIRTUAL_HOST_CHANGE: 'VIRTUAL_HOST_CHANGE',
  VIRTUAL_SHIPPING_CHANGE: 'VIRTUAL_SHIPPING_CHANGE',
  VIRTUAL_COST_CHANGE: 'VIRTUAL_COST_CHANGE'
};
